export default function NotFoundScreen() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(160deg,#042f2e 0%,#0f172a 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 20px",
        fontFamily: "'Nunito', sans-serif",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: 64, marginBottom: 16 }}>🪙</div>
      <div
        style={{
          fontSize: 72,
          fontWeight: 900,
          background: "linear-gradient(135deg,#14b8a6,#f59e0b)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          lineHeight: 1,
          marginBottom: 12,
        }}
      >
        404
      </div>
      <div style={{ fontSize: 20, fontWeight: 700, color: "#f1f5f9", marginBottom: 8 }}>
        Page not found
      </div>
      <div style={{ fontSize: 14, color: "#94a3b8", maxWidth: 280, lineHeight: 1.6, marginBottom: 32 }}>
        That page doesn't exist. Let's get you back on your money mission.
      </div>
      <a
        href="/"
        style={{
          display: "inline-block",
          padding: "14px 32px",
          background: "linear-gradient(135deg,#14b8a6,#0ea5e9)",
          color: "#fff",
          fontWeight: 700,
          fontSize: 15,
          borderRadius: 14,
          textDecoration: "none",
          boxShadow: "0 4px 16px rgba(20,184,166,0.35)",
        }}
      >
        Back to MoneyMission
      </a>
    </div>
  );
}
